import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTUserRewards from "../page/VTUserRewards";

/**
 * Shows customer user rewards for the given venue
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingUserRewards() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserRewards/>
            <Footer/>
        </>
    );
}